import React, { ReactNode } from "react";
import { IWebsiteBuilderRoot, WEBSITE_BUILDER_ROOT_CLASS_NAME } from "../../../../nodes/websiteBuilderRoot";
import { useWebsiteBuilderContext } from "../../../../websiteBuilderContext";
import { useTreeRefMapRegistration } from "../../../../hooks/treeRefMap/useTreeRefMapRegistration";
import { useAppSelector } from "hooks/redux";

interface IWebsiteBuilderRootViewProps {
  node: IWebsiteBuilderRoot;
  header: ReactNode;
  children: ReactNode;
  footer: ReactNode;
}

export function WebsiteBuilderRootView(props: IWebsiteBuilderRootViewProps) {
  const { node, header, children, footer } = props;

  const { treeRefMap } = useWebsiteBuilderContext();
  const treeRefMapRegistration = useTreeRefMapRegistration(node.id, treeRefMap);

  const cssVariables = useAppSelector(store => store.websiteBuilderStore.cssVariables);

  return (
    <div ref={treeRefMapRegistration} className={WEBSITE_BUILDER_ROOT_CLASS_NAME} style={cssVariables}>
      {header}
      {children}
      {footer}
    </div>
  );
}
